import { gql } from '@apollo/client';
const RETRIEVE_TENANT_ORDER_OPERATOR = gql `
  mutation RetrieveOrderOperator($orderOperatorId: ID!) {
    retrieveOrderOperator(orderOperatorId: $orderOperatorId) {
      orderOperator {
        id
        name
        isOrderOperatorRemovable
        canNameBeUpdated
        status
      }
    }
  }
`;
export default RETRIEVE_TENANT_ORDER_OPERATOR;
